import * as Sentry from "@sentry/vue"

export default defineNuxtPlugin((nuxt) => {
  const site = useSiteConfig()

  if (!/production/.test(site.env)) {
    return
  }

  const router = useRouter()

  Sentry.init({
    app: nuxt.vueApp,
    dsn: "https://f185c4a89a1c45d7a7f005f2029747c7@o239822.ingest.sentry.io/6147474",
    release: nuxt.$config.public.app.version ?? "unknown",

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production

    // Disabled Sentry Replays
    // replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.

    // Disabled Sentry Replays
    // replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration({
        router,
        tracingOrigins: ["kunne.net", "kunne.no", "test.kunne.nu"],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
})
